import React from 'react';

const LetterButton = ({ letter, filterLetter, setFilterLetter }) => (
    <button
      className={`letter-button ${filterLetter === letter ? 'active' : ''}`}
      onClick={() => setFilterLetter(letter)}
    >
      {letter}
    </button>
);

export default LetterButton;
